import React, { useEffect, useState } from "react";
import { Check, X } from "lucide-react";

const Toast = ({ message, isVisible, onClose, autoClose = 5000 }) => {
  const [width, setWidth] = useState(100);

  //   useEffect(() => {
  //     if (isVisible && autoClose) {
  //       const timer = setTimeout(onClose, autoClose);
  //       return () => clearTimeout(timer);
  //     }
  //   }, [isVisible, onClose, autoClose]);

  useEffect(() => {
    if (isVisible && autoClose) {
      // Reset width when toast becomes visible
      setWidth(100);

      const startTime = Date.now();
      const endTime = startTime + autoClose;

      const timer = setInterval(() => {
        const now = Date.now();
        const remaining = endTime - now;
        const newWidth = (remaining / autoClose) * 100;

        if (remaining <= 0) {
          clearInterval(timer);
          onClose();
          setWidth(0);
        } else {
          setWidth(Math.max(0, newWidth));
        }
      }, 10);

      return () => {
        clearInterval(timer);
        setWidth(100);
      };
    }
  }, [isVisible, autoClose, onClose]);

  return (
    <div
      className={`fixed top-4 right-4 w-9/12 md:w-7/12 lg:w-5/12 transform  z-50  max-w-sm
        transition-all duration-300 ease-in-out 
        ${
          isVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 -translate-y-4 pointer-events-none"
        }
      `}
    >
      <div className="bg-white rounded-lg shadow-lg p-4 ">
        <div className="flex gap-3 ">
          {/* Success Icon */}
          <div className="shrink-0 flex items-center">
            <div className="w-5 h-5 bg-green-500 rounded-full flex justify-center items-center">
              <Check className="h-4 w-4 text-white" />
            </div>
          </div>

          {/* Message */}
          <div className="flex-1 pt-0.5">
            <p className="text-xs text-gray-700">{message}</p>
          </div>

          {/* Close Button */}
          <div className="flex items-start">
            <button
              onClick={onClose}
              className="shrink-0 mt-0.5 "
              aria-label="Close notification"
            >
              <X className="h-5 w-5 text-gray-400 hover:text-gray-600" />
            </button>
          </div>

          {/* Progress Bar */}
          <div
            className="absolute bottom-0 left-0 h-1 bg-green-500 transition-all duration-300"
            style={{ width: `${width}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default Toast;
